import { createElementObject, createTileLayerComponent, updateGridLayer, withPane } from './core';
// import { TileLayer as LeafletTileLayer } from '@anlan/gs-map';
import L from '@anlan/gs-map';
import type { TileLayer as LeafletTileLayerInstance, TileLayerOptions } from '@anlan/gs-map';
import type { LayerProps, LeafletContextInterface } from './core';
const LeafletTileLayer = L.TileLayer;

export interface TileLayerProps extends TileLayerOptions, LayerProps {
    url: string
}

export const TileLayer = createTileLayerComponent(function createTileLayer({ url , ...options }: TileLayerProps, context: LeafletContextInterface) {
    const layer = new LeafletTileLayer(url, withPane(options, context));
    return createElementObject(layer, context);
}, function updateTileLayer(layer: LeafletTileLayerInstance, props: TileLayerProps, prevProps: TileLayerProps) {
    updateGridLayer(layer, props, prevProps);
    const { url  } = props;
    if (url != null && url !== prevProps.url) {
        layer.setUrl(url);
    }
});
